import "./styles/venue-question.css";

export default function VenueQuestionStep({ onYes, onNo }) {
  return (
    <section className="step fade-in center">
      <h2>Do you know the wedding venue?</h2>
      <div className="btn-row">
        <button className="primary-btn" onClick={onYes}>Yes</button>
        <button className="secondary-btn" onClick={onNo}>Not sure / No</button>
      </div>
    </section>
  );
}